/**
 * Базовая тема - минимальный общий интерфейс для всех приложений
 * Используется в web-booking и как основа для master-app
 */
/**
 * Базовые темы с минимальным набором цветов.
 * Цветовые роли синхронизированы с web-master/src/shared/design/colors/themes/*.
 */
export const baseThemes = {
    /** Синхронизировано с web-master/src/shared/design/colors/themes/light.theme.ts + derivations */
    light: {
        primary: '#FFC107',
        primaryHover: '#FFB300',
        primaryLight: '#FFECB3',
        onPrimaryContainer: '#1B1B1B',
        textPrimary: '#1F2328',
        textSecondary: '#667179',
        textMuted: '#5B616A',
        textOnPrimary: '#1B1B1B',
        bg: '#EEF1F5',
        surface: '#FCFCFD',
        card: '#FFFFFF',
        segmentedTopbarContainer: '#D7DCE4',
        border: '#D7DCE4',
        info: '#4E7FA8',
        success: '#4E8A67',
        warning: '#B9823A',
        danger: '#C85C5C',
        scrim: 'rgba(0, 0, 0, 0.05)',
        apptScheduledBg: '#BBDEFB',
        apptCompletedBg: '#DCEDC8',
        apptNoShowBg: '#FFE0B2',
        apptCancelledBg: '#FFCDD2',
        apptMovedBg: '#E1BEE7',
        apptBreakBg: '#CFD8DC',
    },
    /** Синхронизировано с web-master dark.theme.ts (override primaryLight как в экспорте) */
    dark: {
        primary: '#C9A000',
        primaryHover: '#D4B84A',
        primaryLight: '#3F3C36',
        onPrimaryContainer: '#E8E1D4',
        textPrimary: '#E0E0E0',
        textSecondary: '#7A7A7A',
        textMuted: '#9E9E9E',
        textOnPrimary: '#1B1B1B',
        bg: '#0F0F0F',
        surface: '#1A1A1A',
        card: '#2A2A2A',
        segmentedTopbarContainer: '#0A0A0A',
        border: 'rgba(255, 255, 255, 0.10)',
        info: '#4E7FA8',
        success: '#4E8A67',
        warning: '#B9823A',
        danger: '#C85C5C',
        scrim: 'rgba(0, 0, 0, 0.05)',
        apptScheduledBg: '#5C7A9E',
        apptCompletedBg: '#6B8F6B',
        apptNoShowBg: '#9A7B5A',
        apptCancelledBg: '#9A5C5C',
        apptMovedBg: '#7A6B8A',
        apptBreakBg: '#6B737A',
    },
    pink: {
        primary: '#F48FB1',
        primaryHover: '#EC407A',
        primaryLight: '#FCE4EC',
        onPrimaryContainer: '#1B1B1B',
        textPrimary: '#1F2328',
        textSecondary: '#667179',
        textMuted: '#5B616A',
        textOnPrimary: '#1F2328',
        bg: '#F0E7EC',
        surface: '#F7EFF4',
        card: '#FDF8FB',
        segmentedTopbarContainer: '#DED0DA',
        border: '#E6D8E0',
        info: '#4E7FA8',
        success: '#4E8A67',
        warning: '#B9823A',
        danger: '#C85C5C',
        scrim: 'rgba(0, 0, 0, 0.05)',
        apptScheduledBg: '#BBDEFB',
        apptCompletedBg: '#DCEDC8',
        apptNoShowBg: '#FFE0B2',
        apptCancelledBg: '#FFCDD2',
        apptMovedBg: '#E1BEE7',
        apptBreakBg: '#CFD8DC',
    },
    olive: {
        primary: '#556B2F',
        primaryHover: '#6B8E3E',
        primaryLight: '#A8C68C',
        onPrimaryContainer: '#1B1B1B',
        textPrimary: '#2F4F2F',
        textSecondary: '#667179',
        textMuted: '#556B2F',
        textOnPrimary: '#F5F5DC',
        bg: '#F0EAD6',
        surface: '#F5F5DC',
        card: '#FAF9F0',
        segmentedTopbarContainer: '#DCD0B2',
        border: '#E3D6BF',
        info: '#4E7FA8',
        success: '#4E8A67',
        warning: '#B9823A',
        danger: '#C85C5C',
        scrim: 'rgba(0, 0, 0, 0.05)',
        apptScheduledBg: '#BBDEFB',
        apptCompletedBg: '#DCEDC8',
        apptNoShowBg: '#FFE0B2',
        apptCancelledBg: '#FFCDD2',
        apptMovedBg: '#E1BEE7',
        apptBreakBg: '#CFD8DC',
    },
};
/**
 * Проверяет, является ли строка валидным именем темы
 */
export function isValidThemeName(name) {
    return name in baseThemes;
}
/**
 * Получает базовую тему по имени
 */
export function getBaseTheme(name) {
    return baseThemes[name];
}
//# sourceMappingURL=index.js.map